/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_ModerationInputs */

const en_image_moderation = /** @type {(inputs: Image_ModerationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image Moderation`)
};

const id_image_moderation = /** @type {(inputs: Image_ModerationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderasi Gambar`)
};

/** @type {(inputs: Image_ModerationInputs) => LocalizedString} */
const es_image_moderation = en_image_moderation;

/** @type {(inputs: Image_ModerationInputs) => LocalizedString} */
const fr_image_moderation = en_image_moderation;

/** @type {(inputs: Image_ModerationInputs) => LocalizedString} */
const de_image_moderation = en_image_moderation;

/** @type {(inputs: Image_ModerationInputs) => LocalizedString} */
const ja_image_moderation = en_image_moderation;

/** @type {(inputs: Image_ModerationInputs) => LocalizedString} */
const zh_image_moderation = en_image_moderation;

/** @type {(inputs: Image_ModerationInputs) => LocalizedString} */
const ar_image_moderation = en_image_moderation;

/** @type {(inputs: Image_ModerationInputs) => LocalizedString} */
const it_image_moderation = en_image_moderation;

/** @type {(inputs: Image_ModerationInputs) => LocalizedString} */
const ru_image_moderation = en_image_moderation;

/** @type {(inputs: Image_ModerationInputs) => LocalizedString} */
const pt_image_moderation = en_image_moderation;

/** @type {(inputs: Image_ModerationInputs) => LocalizedString} */
const ko_image_moderation = en_image_moderation;

/**
* | output |
* | --- |
* | "Image Moderation" |
*
* @param {Image_ModerationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const image_moderation = /** @type {((inputs?: Image_ModerationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_ModerationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_image_moderation(inputs)
	if (locale === "es") return es_image_moderation(inputs)
	if (locale === "fr") return fr_image_moderation(inputs)
	if (locale === "de") return de_image_moderation(inputs)
	if (locale === "ja") return ja_image_moderation(inputs)
	if (locale === "zh") return zh_image_moderation(inputs)
	if (locale === "ar") return ar_image_moderation(inputs)
	if (locale === "id") return id_image_moderation(inputs)
	if (locale === "it") return it_image_moderation(inputs)
	if (locale === "ru") return ru_image_moderation(inputs)
	if (locale === "pt") return pt_image_moderation(inputs)
	return ko_image_moderation(inputs)
});